import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PropertyFilter from './PropertyFilter';
import { updateProperties, handleFilter } from '../../../store/actions';
import { PROPERTY_TYPES } from '../../../constants';

/* istanbul ignore next */
const mapStateToProps = (state, { propertyType }) => {
  return {
    organizationId: state.organizationId,
    properties: state[propertyType].items,
    filters: state[propertyType].filters,
    sort: state[propertyType].sort,
    propertySort: state[propertyType].sort,
    propertyType,
    // Subscribing to filterDisplay ensures BuidlingFilter re-renders when switching from areas
    // filters to buildings filters
    filterDisplay: state.filterDisplay,
    previouslySearchedLayer: state.saveSearchedLayers,
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch, { propertyType }) => {
  return {
    onCloseClick: () => dispatch(handleFilter('close')),
    onSortSubmit: (filters, organizationId) => sort => dispatch(
      updateProperties(propertyType, filters, sort, organizationId),
    ),
    onSubmitClick: (currentSort, organizationId, previouslySearchedLayer) => filters => {
      const sortString = filters.get('sort');
      const sort = sortString ? sortString.split(':') : currentSort;
      filters.delete('sort');
      dispatch(
        updateProperties(
          propertyType,
          filters,
          sort,
          organizationId,
          undefined,
          previouslySearchedLayer,
        ),
      );
    },
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { filters, organizationId, sort, previouslySearchedLayer } = stateProps;
  const { onSortSubmit, onSubmitClick } = dispatchProps;
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onSubmitClick: onSubmitClick(sort, organizationId, previouslySearchedLayer),
    onSortSubmit: onSortSubmit(filters, organizationId),
  };
};

const PropertyFilterWrapper = connect(mapStateToProps, mapDispatchToProps, mergeProps)(
  withRouter(PropertyFilter),
);

export function withPropertyTypeFlags(WrappedComponent) {
  function WithPropertyTypeFlags(props) {
    return (
      <WrappedComponent
        {...props}
        isBuildings={PROPERTY_TYPES.BUILDINGS === props.propertyType}
        isSites={PROPERTY_TYPES.SITES === props.propertyType}
      />
    );
  }

  WithPropertyTypeFlags.propTypes = {
    propertyType: PropTypes.string,
  };

  WithPropertyTypeFlags.displayName = `withPropertyTypeFlags(${WrappedComponent.displayName || WrappedComponent.name})`;

  return WithPropertyTypeFlags;
}

export default withPropertyTypeFlags(PropertyFilterWrapper);



// WEBPACK FOOTER //
// ./src/components/Properties/PropertyFilter/PropertyFilterWrapper.js